<template>
    <div>
        <base-header class="pb-6 bg-light">
            <b-row align-v="center" class="py-4">
                <b-col cols="12" lg="6">
                    <h6 class="h2 d-inline-block mb-0 text-dark">ENUM Tool</h6>
                </b-col>
                <b-col cols="12" lg="6" class="text-right">
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-bread-crumb></route-bread-crumb>
                </nav>
                </b-col>
            </b-row>
    
            <div v-if="noAccess">
                <b-card>
                    <b-card-header>
                    <p class="h2 mb-2">
                        <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
                        >&nbsp;Restricted
                    </p>
                    </b-card-header>
                    <b-card-body>Access is Restricted</b-card-body>
                </b-card>
            </div>
            <div v-else>
                <b-card no-body>
                    <b-card-body>
                        <div class="text-right text-primary mb-4 cursor-pointer">
                            <u v-on:click="editSetting()">
                                <i class="fa fa-cog text-primary"></i> {{editConfig}}
                            </u>
                        </div>
                        <b-row>
                            <b-col xl="3" lg="3">
                                <div class="mt-4">
                                    <span  v-for="(item, index) in buttonGroup" v-bind:key="index">
                                        <base-button 
                                            :block="true" 
                                            :type="item.status? 'primary': 'light'" 
                                            v-on:click="selectButton(item.value)">{{item.value}}
                                        </base-button>
                                    </span>
                                </div>
                            </b-col>
                            <b-col xl="9" lg="9">
                                <b-card no-body class="border-non-radius" >
                                    <b-card-header header-tag="header" role="tab">
                                        <h2>{{displayTitle}}</h2>
                                    </b-card-header>

                                    <!-- Edit Config -->
                                    <b-card-body v-if="editConfigStatus">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitConfig)">
                                                    <b-row>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="HEADER_TTL"
                                                                label-for="headerTTL"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="headerTTL"
                                                                    v-model="config.headerTTL"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="ORIGIN"
                                                                label-for="origin"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="origin"
                                                                    v-model="config.origin"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="SOA"
                                                                label-for="soa"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="soa"
                                                                    v-model="config.soa"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="REFRESH"
                                                                label-for="refresh"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="refresh"
                                                                    v-model="config.refresh"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="RETRY"
                                                                label-for="retry"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="retry"
                                                                    v-model="config.retry"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="EXPIRY"
                                                                label-for="expiry"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="expiry"
                                                                    v-model="config.expiry"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="TTL_RECORD"
                                                                label-for="ttlRecord"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="ttlRecord"
                                                                    v-model="config.ttlRecord"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="NS_RECORD"
                                                                label-for="nsRecord"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="nsRecord"
                                                                    v-model="config.nsRecord"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="A_RECORD"
                                                                label-for="aRecord"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="aRecord"
                                                                    v-model="config.aRecord"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="SIP_NETWORK"
                                                                label-for="sipNetwork"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="sipNetwork"
                                                                    v-model="config.sipNetwork"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="SIP_ADDRESS"
                                                                label-for="sipAddress"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="sipAddress"
                                                                    v-model="config.sipAddress"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="ZONE_FILEPATH"
                                                                label-for="zoneFilePath"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="zoneFilePath"
                                                                    v-model="config.zoneFilePath"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="TEMP_DIR"
                                                                label-for="tempDir"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="tempDir"
                                                                    v-model="config.tempDir"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="RNDC_PATH"
                                                                label-for="rndcPath"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="rndcPath"
                                                                    v-model="config.rndcPath"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DB_PATH"
                                                                label-for="dbPath"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="dbPath"
                                                                    v-model="config.dbPath"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEBUG_COMMENTS"
                                                                label-for="debugComments"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="debugComments"
                                                                    v-model="config.debugComments"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEDUPE_OUTPUT"
                                                                label-for="dedupeOutput"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="dedupeOutput"
                                                                    v-model="config.dedupeOutput"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="RELOAD_SERVICE"
                                                                label-for="reloadService"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="reloadService"
                                                                    v-model="config.reloadService"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_SIP_NETWORK_HEADER"
                                                                label-for="defaultSipNetworkHeader"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="defaultSipNetworkHeader"
                                                                    v-model="config.defaultSipNetworkHeader"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_1_DIGIT"
                                                                label-for="default1Digit"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="default1Digit"
                                                                    v-model="config.default1Digit"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_11_DIGIT_EXACT_MATCH"
                                                                label-for="default11DigitExactMatch"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="default11DigitExactMatch"
                                                                    v-model="config.default11DigitExactMatch"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_11_DIGIT_NOT_EXACT_MATCH"
                                                                label-for="default11DigitNotExactMatch"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="default11DigitNotExactMatch"
                                                                    v-model="config.default11DigitNotExactMatch"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_10_DIGIT_NOT_EXACT_MATCH"
                                                                label-for="default10DigitNotExactMatch"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="default10DigitNotExactMatch"
                                                                    v-model="config.default10DigitNotExactMatch"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_7_DIGIT_NOT_EXACT_MATCH"
                                                                label-for="default7DigitNotExactMatch"
                                                                class="mb-2"
                                                            >
                                                                <b-form-input
                                                                    id="default7DigitNotExactMatch"
                                                                    v-model="config.default7DigitNotExactMatch"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-form-group
                                                                label="DEFAULT_CUSTOM_STATIC_HEADER"
                                                                label-for="defaultCustomStaticHeader"
                                                                class="mb-0"
                                                            >
                                                                <b-form-textarea
                                                                    id="defaultCustomStaticHeader"
                                                                    rows="5"
                                                                    v-model="config.defaultCustomStaticHeader"
                                                                ></b-form-textarea>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <base-button type="primary"  title="Submit" nativeType="submit" class="w-100 h-100" :loading="submitLoadingStatus">
                                                                Submit
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Add Single Number -->
                                    <b-card-body v-if="buttonGroup[0].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitAddSingleNumber)">
                                                    <validation-provider
                                                        name="msisdn"
                                                        :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                        v-slot="validationContext"
                                                        >
                                                        <b-input-group id="msisdn" class="mb-0" >
                                                            <b-form-input
                                                                id="msisdn"
                                                                name="msisdn"
                                                                v-model="addSingleNumber.msisdn"
                                                                aria-describedby="msisdn"
                                                                placeholder="Msisdn ex: 18889990000"
                                                                :state="getValidation1State(validationContext)"
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback id="msisdn">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </validation-provider>
                                                    
                                                    <validation-provider
                                                        name="domain"
                                                        :rules="{ required: true }"
                                                        v-slot="validationContext"
                                                        >
                                                        <b-input-group id="domain" class="mb-0 mt-2" >
                                                            <b-form-input
                                                                id="domain"
                                                                name="domain"
                                                                v-model="addSingleNumber.domain"
                                                                aria-describedby="domain"
                                                                placeholder="Domain ex: ims.mnc999.mcc999.3gppnetwork.org"
                                                                :state="getValidation1State(validationContext)"
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback id="domain">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </validation-provider>
    
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Add Single Number" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Add
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                    <p class="text-center font-weight-500 text-danger mt-5">
                                                        <i>Node: If domain is left blank, the msisdn will be mapped to your default SIP_ADDRESS setting.</i>
                                                    </p>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Remove Single Number -->
                                    <b-card-body v-if="buttonGroup[1].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitRemoveSingleNumber)">
                                                    <validation-provider
                                                        name="number"
                                                        :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                        v-slot="validationContext"
                                                        >
                                                        <b-input-group id="number" class="mb-0" >
                                                            <b-form-input
                                                                id="number"
                                                                name="number"
                                                                v-model="removeSingleNumber.number"
                                                                aria-describedby="number"
                                                                :state="getValidation2State(validationContext)"
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback id="number">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </validation-provider>
    
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Remove Single Number" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Remove
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Query Single Number -->
                                    <b-card-body v-if="buttonGroup[2].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitQuerySingleNumber)">
                                                    <validation-provider
                                                        name="number"
                                                        :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                        v-slot="validationContext"
                                                        >
                                                        <b-input-group id="number" class="mb-0" >
                                                            <b-form-input
                                                                id="number"
                                                                name="number"
                                                                v-model="querySingleNumber.number"
                                                                aria-describedby="number"
                                                                :state="getValidation3State(validationContext)"
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback id="number">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </validation-provider>
    
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Query Single Number" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Query
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Add Range of Numbers -->
                                    <b-card-body v-if="buttonGroup[3].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitAddRangeOfNumber)">
                                                    <b-row>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="from"
                                                                :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                                v-slot="validationContext"
                                                                >
                                                                <b-input-group id="from" class="mb-0" >
                                                                    <b-form-input
                                                                        id="from"
                                                                        name="from"
                                                                        v-model="addRangeOfNumber.from"
                                                                        aria-describedby="from"
                                                                        placeholder="From ex: 18889990000"
                                                                        :state="getValidation4State(validationContext)"
                                                                    ></b-form-input>
                                                                    <b-form-invalid-feedback id="from">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                                </b-input-group>
                                                            </validation-provider>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="to"
                                                                :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                                v-slot="validationContext"
                                                                >
                                                                <b-input-group id="to" class="mb-0" >
                                                                    <b-form-input
                                                                        id="to"
                                                                        name="to"
                                                                        v-model="addRangeOfNumber.to"
                                                                        aria-describedby="to"
                                                                        placeholder="To ex: 18889990010"
                                                                        :state="getValidation4State(validationContext)"
                                                                    ></b-form-input>
                                                                    <b-form-invalid-feedback id="to">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                                </b-input-group>
                                                            </validation-provider>
                                                        </b-col>
                                                    </b-row>
                                                    
                                                    
                                                    <validation-provider
                                                        name="domain"
                                                        :rules="{ required: true }"
                                                        v-slot="validationContext"
                                                        >
                                                        <b-input-group id="domain" class="mb-0 mt-2" >
                                                            <b-form-input
                                                                id="domain"
                                                                name="domain"
                                                                v-model="addRangeOfNumber.domain"
                                                                aria-describedby="domain"
                                                                placeholder="Domain ex: ims.mnc999.mcc999.3gppnetwork.org"
                                                                :state="getValidation1State(validationContext)"
                                                            ></b-form-input>
                                                            <b-form-invalid-feedback id="domain">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                        </b-input-group>
                                                    </validation-provider>
    
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Add Range of Number" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Add Range
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                    <p class="text-center font-weight-500 text-danger mt-5">
                                                        <i>Node: If domain is left blank, the msisdn will be mapped to your default SIP_ADDRESS setting.</i>
                                                    </p>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Remove Range of Number -->
                                    <b-card-body v-if="buttonGroup[4].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitRemoveRangeOfNumber)">
                                                    <b-row>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="from"
                                                                :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                                v-slot="validationContext"
                                                                >
                                                                <b-input-group id="from" class="mb-0" >
                                                                    <b-form-input
                                                                        id="from"
                                                                        name="from"
                                                                        v-model="removeRangeOfNumber.from"
                                                                        aria-describedby="from"
                                                                        :state="getValidation5State(validationContext)"
                                                                    ></b-form-input>
                                                                    <b-form-invalid-feedback id="from">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                                </b-input-group>
                                                            </validation-provider>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <validation-provider
                                                                name="to"
                                                                :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                                v-slot="validationContext"
                                                                >
                                                                <b-input-group id="to" class="mb-0" >
                                                                    <b-form-input
                                                                        id="to"
                                                                        name="to"
                                                                        v-model="removeRangeOfNumber.to"
                                                                        aria-describedby="to"
                                                                        :state="getValidation5State(validationContext)"
                                                                    ></b-form-input>
                                                                    <b-form-invalid-feedback id="to">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                                </b-input-group>
                                                            </validation-provider>
                                                        </b-col>
                                                    </b-row>
    
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Remove Range of Number" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Remove Range
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- List Zone File -->
                                    <b-card-body v-if="buttonGroup[5].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitListZoneFile)">
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="List Zone" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                List Zone
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- List Numbers -->
                                    <b-card-body v-if="buttonGroup[6].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitListNumbers)">
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="List Numbers to Screen" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                List Numbers to Screen
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Export CSV File -->
                                    <b-card-body v-if="buttonGroup[7].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitExportCSVFile)">
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Export Numbers as CSV" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Export Numbers as CSV
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <!-- Add CSV File -->
                                    <b-card-body v-if="buttonGroup[8].status">
                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Input</h3>
                                            </template>
                                            <validation-observer ref="" v-slot="{ handleSubmit }" >
                                                <b-form @submit.stop.prevent="handleSubmit(submitAddCSVFile)">
                                                    <b-form-file  ref="file-input" class="mb-2" @change="handleFileUpload($event)"></b-form-file>
                                                    <b-row class="mt-2">
                                                        <b-col lg="3">
                                                            <base-button type="primary"  title="Add CSV" nativeType="submit" class="w-100" :loading="submitLoadingStatus">
                                                                Add CSV
                                                            </base-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form>
                                            </validation-observer>
                                        </b-card>

                                        <b-card header-tag="header" class="custom-card-header">
                                            <template #header >
                                              <h3 class="mb-0">Response</h3>
                                            </template>
                                            <pre>{{responseResult}}</pre>
                                        </b-card>
                                    </b-card-body>

                                    <p class="text-center font-weight-400">{{version}}</p>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
               
            </div>
        </base-header>
    </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import initService from "@/common/api-services/init-service";
import {ValidationProvider} from 'vee-validate';
import eNumDashboardService from "../../../common/api-services/enum-dashboard-service";
import formatType from '../../../common/format/format-type';
import cryptoJS from 'crypto-js';

export default {
    name: 'enum-tool',
    components: {
        RouteBreadCrumb,
        ValidationProvider
    },
    data() {
        return {
            version: '',
            config: {
                headerTTL: '',
                origin: '',
                soa: '',
                refresh: '',
                retry: '',
                expiry: '',
                ttlRecord: '',
                nsRecord: '',
                aRecord: '',
                sipNetwork: '',
                sipAddress: '',
                zoneFilePath: '',
                tempDir: '',
                rndcPath: '',
                dbPath: '',
                debugComments: '',
                dedupeOutput: '',
                reloadService: '',
                defaultSipNetworkHeader: '',
                default1Digit: '',
                default11DigitExactMatch: '',
                default11DigitNotExactMatch: '',
                default10DigitNotExactMatch: '',
                default7DigitNotExactMatch: '',
                defaultCustomStaticHeader: ''
            },
            editConfig: 'Edit Config',
            buttonGroup: [
                {status: true, value: 'Add Single Number'},
                {status: false, value: 'Remove Single Number'},
                {status: false, value: 'Query Single Number'},
                {status: false, value: 'Add Range of Numbers'},
                {status: false, value: 'Remove Range of Numbers'},
                {status: false, value: 'List Zone File'},
                {status: false, value: 'List Numbers'},
                {status: false, value: 'Export CSV File'},
                {status: false, value: 'Add CSV File'}
            ],
            displayTitle: 'Add single Number',
            addSingleNumber: {
                msisdn: '',
                domain: ''
            },
            removeSingleNumber: {
                number: 0
            },
            querySingleNumber: {
                number: 12
            },
            addRangeOfNumber: {
                from: '',
                to: '',
                domain: ''
            },
            removeRangeOfNumber: {
                from: '',
                to: ''
            },
            addCSVFile: {
                csv: null
            },
            noAccess: true,
            submitLoadingStatus: false,
            responseResult: '',
            editConfigStatus: false
        }
    },
    mounted() {
        document.title = 'ENUM Tool';
        //The user needs to be notified that this is not accessible.
        this.noAccess =
                !initService.getUserRoles().includes("Administrator") &&
                !initService.getUserRoles().includes("OTA_ADMIN") &&
                !initService.getUserRoles().includes("OTA_READ") &&
                !initService.getUserRoles().includes("OTA_EDIT");
         
        this.getVersion();
    },
    methods: {
        async getVersion() {
            eNumDashboardService.getENumVersion().then(res => {
                this.version = res.data.message;
            }) 
        },

        selectButton(value) {
            this.editConfigStatus = false;
            this.displayTitle = value;
            this.responseResult = '';
            this.buttonGroup.map(item => {
                if (item.value === value) {
                    item.status = true
                } else {
                    item.status = false
                }
            })
        },

        getValidation1State({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},
        getValidation2State({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},
        getValidation3State({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},
        getValidation4State({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},
        getValidation5State({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},

        editSetting() {
            this.editConfigStatus = true;
            this.buttonGroup.map(item => {
                item.status = false
            });
            this.displayTitle = this.editConfig;
            eNumDashboardService.getConfig().then(res => {
                let response = res.data.message;
                this.config.aRecord =  this.decrypt(response.A_RECORD);
                this.config.dbPath = this.decrypt(response.DB_PATH);
                this.config.debugComments = this.decrypt(response.DEBUG_COMMENTS);
                this.config.dedupeOutput = this.decrypt(response.DEDUPE_OUTPUT);
                this.config.default1Digit = this.decrypt(response.DEFAULT_1_DIGIT);
                this.config.default7DigitNotExactMatch = this.decrypt(response.DEFAULT_7_DIGIT_NOT_EXACT_MATCH);
                this.config.default10DigitNotExactMatch = this.decrypt(response.DEFAULT_10_DIGIT_NOT_EXACT_MATCH);
                this.config.default11DigitExactMatch = this.decrypt(response.DEFAULT_11_DIGIT_EXACT_MATCH);
                this.config.default11DigitNotExactMatch = this.decrypt(response.DEFAULT_11_DIGIT_NOT_EXACT_MATCH);
                this.config.defaultCustomStaticHeader = this.decrypt(response.DEFAULT_CUSTOM_STATIC_HEADER);
                this.config.defaultSipNetworkHeader = this.decrypt(response.DEFAULT_SIP_NETWORK_HEADER);
                this.config.expiry = this.decrypt(response.EXPIRY);
                this.config.headerTTL = this.decrypt(response.HEADER_TTL);
                this.config.nsRecord = this.decrypt(response.NS_RECORD);
                this.config.origin = this.decrypt(response.ORIGIN);
                this.config.refresh = this.decrypt(response.REFRESH);
                this.config.reloadService = this.decrypt(response.RELOAD_SERVICE);
                this.config.retry = this.decrypt(response.RETRY);
                this.config.rndcPath = this.decrypt(response.RNDC_PATH);
                this.config.sipAddress = this.decrypt(response.SIP_ADDRESS);
                this.config.sipNetwork = this.decrypt(response.SIP_NETWORK);
                this.config.soa = this.decrypt(response.SOA);
                this.config.tempDir = this.decrypt(response.TEMP_DIR);
                this.config.ttlRecord = this.decrypt(response.TTL_RECORD);
                this.config.zoneFilePath = this.decrypt(response.ZONE_FILEPATH);
            })
        },

        decrypt(param) {
             if (param) {
                return cryptoJS.enc.Utf8.stringify(cryptoJS.enc.Base64.parse(param))
             }
        },

        encrypt(param) {
            let str;
            if (param) {
                str = '"' + cryptoJS.enc.Base64.stringify(cryptoJS.enc.Utf8.parse(param)) + '"';
            }
            return str;
        },

        submitAddSingleNumber() {
            this.submitLoadingStatus = true;
            eNumDashboardService.addSingleNumber(this.addSingleNumber).then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitRemoveSingleNumber() {
            this.submitLoadingStatus = true;
            eNumDashboardService.removeSingleNumber(this.removeSingleNumber.number).then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitQuerySingleNumber() {
            this.submitLoadingStatus = true;
            eNumDashboardService.querySingleNumber(this.querySingleNumber.number).then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitAddRangeOfNumber() {
            this.submitLoadingStatus = true;
            eNumDashboardService.addNumberRange(this.addRangeOfNumber).then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitRemoveRangeOfNumber() {
            this.submitLoadingStatus = true;
            eNumDashboardService.removeNumberRange(this.removeRangeOfNumber).then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitListZoneFile() {
            this.submitLoadingStatus = true;
            eNumDashboardService.listZoneFile().then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitListNumbers() {
            this.submitLoadingStatus = true;
            eNumDashboardService.listNumbers().then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = res.data.message;
                }
            })
        },

        submitExportCSVFile() {
            this.submitLoadingStatus = true;
            eNumDashboardService.exportCSVFile().then(res => {
                this.submitLoadingStatus = false;
                if (res.data.status) {
                    this.responseResult = 'Export Complete.';
                    formatType.jsonToText(res.data.message, "e164_arpa_db_extract.csv");
                }
            })
        },

        submitAddCSVFile() {
            this.submitLoadingStatus = true;
            eNumDashboardService.moveUpLoadedFile(this.addCSVFile.csv).then(res => {
                eNumDashboardService.loadCSV(res.data).then(resp=> {
                    this.submitLoadingStatus = false;
                    if (resp.data.status) {
                        this.responseResult = resp.data.message;
                    }
                })
            })
            
        },

        handleFileUpload(event) {
            this.addCSVFile.csv = event.target.files[0];
        },

        submitConfig() {
            let  configData = {
                HEADER_TTL: this.config.headerTTL,
                ORIGIN: this.config.origin,
                SOA: this.config.soa,
                REFRESH: this.config.refresh,
                RETRY: this.config.retry,
                EXPIRY: this.config.expiry,
                TTL_RECORD: this.config.ttlRecord,
                NS_RECORD: this.config.nsRecord,
                A_RECORD: this.config.aRecord,
                SIP_NETWORK: this.config.sipNetwork,
                SIP_ADDRESS: this.config.sipAddress,
                ZONE_FILEPATH: this.config.zoneFilePath,
                TEMP_DIR: this.config.tempDir,
                RNDC_PATH: this.config.rndcPath,
                DB_PATH: this.config.dbPath,
                DEBUG_COMMENTS: this.config.debugComments,
                DEDUPE_OUTPUT: this.config.dedupeOutput,
                RELOAD_SERVICE: this.config.reloadService,
                DEFAULT_1_DIGIT: this.config.default1Digit,
                DEFAULT_11_DIGIT_EXACT_MATCH: this.config.default11DigitExactMatch,
                DEFAULT_11_DIGIT_NOT_EXACT_MATCH: this.config.default11DigitNotExactMatch,
                DEFAULT_10_DIGIT_NOT_EXACT_MATCH: this.config.default10DigitNotExactMatch,
                DEFAULT_7_DIGIT_NOT_EXACT_MATCH: this.config.default7DigitNotExactMatch,
                DEFAULT_SIP_NETWORK_HEADER: this.config.defaultSipNetworkHeader,
                DEFAULT_CUSTOM_STATIC_HEADER: this.config.defaultCustomStaticHeader,
            };
            eNumDashboardService.updateConfig(configData).then(res => {
                console.log(res)
            })
        }
          
    }
}
</script>